{
  "GENERAL_SETTINGS": {
    "TITLE": "Налаштування облікового запису",
    "SUBMIT": "Оновити налаштування",
    "BACK": "Назад",
    "DISMISS": "Відхилити",
    "UPDATE": {
      "ERROR": "Не вдалося оновити налаштування, спробуйте ще раз!",
      "SUCCESS": "Налаштування облікового запису успішно оновлено"
    },
    "FORM": {
      "ERROR": "Будь ласка, виправте помилки форми",
      "GENERAL_SECTION": {
        "TITLE": "Загальні налаштування",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID акаунту",
        "NOTE": "Цей ID необхідний, якщо ви створюєте інтеграцію з API"
      },
      "NAME": {
        "LABEL": "Назва облікового запису",
        "PLACEHOLDER": "Ім'я вашого облікового запису",
        "ERROR": "Будь ласка, введіть правильне ім'я облікового запису"
      },
      "LANGUAGE": {
        "LABEL": "Мова сайту",
        "PLACEHOLDER": "Ім'я вашого облікового запису",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Домен вхідної пошти",
        "PLACEHOLDER": "Домен, на який ви будете отримувати електронні листи",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Email підтримки",
        "PLACEHOLDER": "Email підтримки вашої компанії",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Кількість днів після того, як заявка повинна автоматично буде закрита, якщо немає активності",
        "PLACEHOLDER": "30",
        "ERROR": "Будь ласка, введіть допустиму тривалість автозакртиття (мінімум 1 день і максимум 999 днів)",
        "NOTE": "Кількість годин неактивності, після якої будь-яка відкрита розмова буде автоматично вирішена."
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Продовження діалогу з е-поштою активоване для вашого облікового запису.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Тепер ви можете отримувати електронні листи на власний домен."
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Кількість днів, після яких порожня розмова має автоматично вирішуватися, якщо немає активності",
        "PLACEHOLDER": "ніколи",
        "ERROR": "Будь ласка, введіть дійсну тривалість автоматичного вирішення порожньої розмови (мінімум 1 день, максимум 999 днів)"
      },
      "PHONE": {
        "TITLE": "Налаштування PBX",
        "NOTE": "Налаштуйте підключення до вашої PBX для телефонних викликів",
        "SIP_HOST": {
          "LABEL": "Домен SIP"
        },
        "DIALING_MODE": {
          "LABEL": "Режим набору",
          "MODES": {
            "direct": "Прямий — виклик набирається одразу після кліку на посилання телефону",
            "indirect": "Непрямий — номер телефону підготовано у полі вводу віджета телефону"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Доступ до записів викликів",
          "MODES": {
            "admin_only": "Лише адміністратори",
            "admin_and_assigned_agent": "Адміністратори та призначений агент",
            "inbox_members": "Усі агенти з доступом до інбоксу"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Налаштування Email",
        "NOTE": "Змінює поведінку email-інбоксів"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Режим відображення часової мітки розмови",
        "MODES": {
          "both": "Створення та остання активність",
          "last_activity_only": "Лише остання активність",
          "last_customer_message": "Останнє повідомлення клієнта"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Блокувати домени з низькою репутацією"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Включати оригінальне повідомлення у відповідь на email"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Автоматично вирішувати нову розмову"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Автоматично переміщувати нову розмову електронною поштою до скриньки робота, який обробив замовлення контакту"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Розширені мітки — дозволити довші назви міток зі збільшеним інтерфейсом"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent — автоматично призначати розмову агенту, який створив останню відповідь"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Режим push-сповіщень",
        "MODES": {
          "all_inboxes": "Усі інбокси — надсилати сповіщення для всіх типів каналів",
          "chat_only": "Лише чат — надсилати сповіщення лише для неemail-каналів"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Дозволити перемикання підпису у надісланих повідомленнях"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Відображати статус чату агента на wallboard"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Показувати повні назви вкладень без обрізання"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Вхід за паролем",
        "MODES": {
          "allowed_for_all": "Дозволено для всіх користувачів",
          "allowed_for_agents_only": "Дозволено лише агентам (адміністратори мають використовувати OAuth)",
          "password_login_disabled": "Вимкнено — лише OAuth"
        }
      }
    },
    "LEARN_MORE": "Детальніше",
    "PAYMENT_PENDING": "Очікується ваш платіж. Будь ласка, оновіть вашу платіжну інформацію, щоб продовжити використовувати контакт-центр",
    "LIMITS_UPGRADE": "В вашому обліковому записі перевищено ліміт використання, будь ласка, поновіть ваш план, щоб продовжити використання контакт-центру",
    "OPEN_BILLING": "Відкрити рахунок",
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Ви перевищили ліміт розмов. Тариф Hacker дозволяє лише 500 розмов.",
      "INBOXES": "Ви перевищили ліміт інбоксів. Тариф Hacker підтримує лише живий чат на сайті. Додаткові інбокси, як-от email, WhatsApp тощо, потребують платного тарифу.",
      "AGENTS": "Ви перевищили ліміт агентів. Тариф Hacker дозволяє лише 2 агентів.",
      "NON_ADMIN": "Зверніться до свого адміністратора, щоб оновити тариф і продовжити користуватися всіма можливостями."
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Видалити свій обліковий запис",
      "NOTE": "Після видалення облікового запису всі ваші дані буде видалено.",
      "BUTTON_TEXT": "Видалити обліковий запис",
      "CONFIRM": {
        "TITLE": "Видалити обліковий запис",
        "MESSAGE": "Видалення облікового запису незворотне. Введіть назву облікового запису нижче, щоб підтвердити його остаточне видалення.",
        "BUTTON_TEXT": "Видалити",
        "DISMISS": "Скасувати",
        "PLACE_HOLDER": "Будь ласка, введіть {accountName} для підтвердження"
      },
      "SUCCESS": "Обліковий запис позначено для видалення",
      "FAILURE": "Не вдалося видалити обліковий запис, спробуйте ще раз!",
      "SCHEDULED_DELETION": {
        "TITLE": "Обліковий запис заплановано для видалення",
        "MESSAGE_MANUAL": "Цей обліковий запис заплановано для видалення {deletionDate}. Це було запитано адміністратором. Ви можете скасувати видалення до цієї дати.",
        "MESSAGE_INACTIVITY": "Цей обліковий запис заплановано для видалення {deletionDate} через неактивність. Ви можете скасувати видалення до цієї дати.",
        "CLEAR_BUTTON": "Скасувати заплановане видалення"
      }
    },
    "NEW_VERSION_AVAILABLE": "Доступна нова версія. Перезавантажте сторінку, щоб отримати останні оновлення.",
    "RELOAD_NOW": "Оновити зараз"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Натисніть Enter, щоб обрати",
      "ENTER_TO_REMOVE": "Натисніть Enter, щоб видалити",
      "NO_OPTIONS": "Список порожній",
      "NO_RESULT": "Нічого не знайдено",
      "SELECT_ONE": "Виберіть",
      "SELECT": "Обрати"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Сповіщення",
    "MARK_ALL_DONE": "Позначити все готове",
    "DELETE_TITLE": "видалено",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Непрочитані сповіщення",
      "ALL_NOTIFICATIONS": "Переглянути всі сповіщення",
      "LOADING_UNREAD_MESSAGE": "Завантаження непрочитаних сповіщень...",
      "EMPTY_MESSAGE": "У вас немає непрочитаних сповіщень"
    },
    "LIST": {
      "LOADING_MESSAGE": "Завантаження сповіщень...",
      "404": "Немає сповіщень",
      "TABLE_HEADER": [
        "Ім'я",
        "Номер телефону",
        "Бесіди",
        "Останній контакт"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Новий діалог",
      "conversation_assignment": "Діалог призначений",
      "assigned_conversation_new_message": "Нове повідомлення",
      "participating_conversation_new_message": "Нове повідомлення",
      "conversation_mention": "Відмітка",
      "sla_missed_first_response": "SLA пропущено",
      "sla_missed_next_response": "SLA пропущено",
      "sla_missed_resolution": "SLA пропущено"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Не в мережі",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Оновити"
    },
    "CONNECTION_LOST": {
      "TITLE": "З'єднання втрачено",
      "DESCRIPTION": "Не вдалося підключитися до сервера. Перевірте з'єднання та повторіть спробу.",
      "RETRY": "Повторити спробу"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Шукати чи перейти до",
    "SECTIONS": {
      "GENERAL": "Загальні",
      "REPORTS": "Звіти",
      "CONVERSATION": "Діалог",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Змінити виконавця",
      "CHANGE_PRIORITY": "Змінити пріоритет",
      "CHANGE_TEAM": "Змінити команду",
      "SNOOZE_CONVERSATION": "Відкласти розмову",
      "EXECUTE_MACRO": "Виконати макрос",
      "ADD_LABEL": "Додати мітку до діалогу",
      "REMOVE_LABEL": "Видалити мітку з діалогу",
      "SETTINGS": "Налаштування",
      "AI_ASSIST": "ШІ асистент",
      "APPEARANCE": "Оформлення",
      "SNOOZE_NOTIFICATION": "Відключити сповіщення"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Перейти до панелі керування бесід",
      "GO_TO_CONTACTS_DASHBOARD": "Перейти до панелі керування контактами",
      "GO_TO_REPORTS_OVERVIEW": "До Звітів",
      "GO_TO_CONVERSATION_REPORTS": "Перейти до Звітів про розмову",
      "GO_TO_AGENT_REPORTS": "Перейти до звітів Співробітника",
      "GO_TO_LABEL_REPORTS": "Перейти до Звітів з Мітками",
      "GO_TO_INBOX_REPORTS": "Перейти до Вхідних Звітів",
      "GO_TO_TEAM_REPORTS": "Перейти до Командних Звітів",
      "GO_TO_SETTINGS_AGENTS": "Перейдіть до налаштувань Співробітника",
      "GO_TO_SETTINGS_TEAMS": "Перейти до Налаштування команди",
      "GO_TO_SETTINGS_INBOXES": "Перейти до Налаштування вхідних повідомлень",
      "GO_TO_SETTINGS_LABELS": "Перейти до Налаштування Міток",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "До налаштувань швидкої відповіді",
      "GO_TO_SETTINGS_APPLICATIONS": "Перейти до Налаштування додатку",
      "GO_TO_SETTINGS_ACCOUNT": "Перейти до Налаштування облікового запису",
      "GO_TO_SETTINGS_PROFILE": "Перейти до Налаштування профілю",
      "GO_TO_NOTIFICATIONS": "Перейти до сповіщень",
      "ADD_LABELS_TO_CONVERSATION": "Додати мітку до діалогу",
      "ASSIGN_AN_AGENT": "Призначити агента",
      "AI_ASSIST": "ШІ асистент",
      "ASSIGN_PRIORITY": "Призначити пріоритет",
      "ASSIGN_A_TEAM": "Призначити команду",
      "EXECUTE_A_MACRO": "Виконати макрос",
      "MUTE_CONVERSATION": "Вимкнути звук для розмови",
      "UNMUTE_CONVERSATION": "Увімкнути звук для розмови",
      "REMOVE_LABEL_FROM_CONVERSATION": "Видалити мітку з діалогу",
      "REOPEN_CONVERSATION": "Повторно відкрити розмову",
      "RESOLVE_CONVERSATION": "Закрити розмову",
      "SEND_TRANSCRIPT": "Надіслати історію розмови на електронну пошту",
      "SNOOZE_CONVERSATION": "Відкласти розмову",
      "UNTIL_NEXT_REPLY": "До наступної відповіді",
      "UNTIL_NEXT_WEEK": "До наступного тижня",
      "UNTIL_TOMORROW": "До завтра",
      "UNTIL_NEXT_MONTH": "До наступного місяця",
      "AN_HOUR_FROM_NOW": "На годину з цього моменту",
      "UNTIL_CUSTOM_TIME": "Власний...",
      "CHANGE_APPEARANCE": "Змінити зовнішній вигляд",
      "LIGHT_MODE": "Світла",
      "DARK_MODE": "Темна",
      "SYSTEM_MODE": "Система",
      "SNOOZE_NOTIFICATION": "Відключити сповіщення"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Завантаження дашборду..."
  },
  "COMMON": {
    "OR": "Або",
    "CLICK_HERE": "натисніть тут"
  }
}
